// extracted by mini-css-extract-plugin
export default {"businessMapComplaint":"complaint_businessMapComplaint__ESz6T","trigger":"complaint_trigger__+6+4h"};